// extracted by mini-css-extract-plugin
module.exports = {"con":"layout2-module--con--33YA0","main":"layout2-module--main--13hpn","twoimage":"layout2-module--twoimage--2GpDx","list":"layout2-module--list--XCgKG"};